export { default } from "./ThemeProvider.mjs";